import { Box, Divider, Drawer, Stack, Tab, Tabs } from '@mui/material';
import { getUserActivity } from 'features/account/service/AccountProfileService';
import React, { useEffect, useState } from 'react';
import { ActivityLogCard } from 'components/activity-log/ActivityLog';

const AccountActivityLog = ({ isOpen, onClose, onBack }) => {
  const [currentTab, setCurrentTab] = useState('personal');
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    getActivityLogAPI();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab])

  const getActivityLogAPI = async () => {
    const response = await getUserActivity(currentTab);
    setLogs(response?.data);
  };

  const handleChange = (_, newTab) => {
    setCurrentTab(newTab);
  };

  const TabPanel = ({ children, panel, panelName, ...other }) => {
    return (
      <div
        className='h-full'
        role='tabpanel'
        hidden={panel !== panelName}
        id={`tabpanel-${panelName}`}
        aria-labelledby={`tab-${panelName}`}
        {...other}
      >
        {panel === panelName && (
          <Box height='100%'>
            {logs ? (
              <Stack divider={<Divider/>}>
                {logs?.map((log) => {
                  return (
                    <ActivityLogCard log={log}/>
                  )
                  }
                )}
              </Stack>) : (
                <Stack justifyContent='center' alignItems='center' height='100%'>
                  <img
                    alt='table-empty-icon'
                    src='/images/table-empty-state-no-skeleton.svg'
                  />
                </Stack>
              )
            }
          </Box>
        )}
      </div>
    );
  };

  return (
    <Drawer
      className='account-profile-drawer'
      anchor='right'
      open={isOpen}
      onClose={onClose}
    >
      <Stack
        className='header'
        direction='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <img
          alt='close-profile-icon'
          className='cursor-pointer'
          src='/images/sidebar/sidebar-back.svg'
          onClick={onBack}
        />
        <p className='account-profile-title'>Account Activity Log</p>
        <img
          alt='close-profile-icon'
          className='cursor-pointer'
          src='/images/close-profile-icon.svg'
          onClick={onClose}
        />
      </Stack>
      <Stack className='container'>
        <Tabs indicatorColor='#000' value={currentTab} onChange={handleChange} variant='fullWidth'>
          <Tab value='personal' label='Personal Information' />
          <Tab value='login' label='Login Information' />
          <Tab value='security' label='Security' />
        </Tabs>
        <TabPanel panel={currentTab} panelName='personal' />
        <TabPanel panel={currentTab} panelName='login' />
        <TabPanel panel={currentTab} panelName='security' />
      </Stack>
    </Drawer>
  );
};

export default AccountActivityLog;
